module.exports = __webpack_public_path__ + "img/289-3f527a.png";